import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-036131d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Reports")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Sign out")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-double-left" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SidebarLink = _resolveComponent("SidebarLink")

  return (_openBlock(), _createElementBlock("div", {
    class: "sidebar",
    style: _normalizeStyle({ width: $setup.sidebarWidth })
  }, [
    _createElementVNode("h1", null, [
      ($setup.collapsed)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "G"))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "GOKU"))
    ]),
    _createVNode(_component_SidebarLink, {
      to: "/",
      icon: "fas fa-chart-bar"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_SidebarLink, {
      to: "/signout",
      icon: "fas fa-sign-out-alt"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createElementVNode("span", {
      class: _normalizeClass(["collapse-icon", { 'rotate-180': $setup.collapsed }]),
      onClick: _cache[0] || (_cache[0] = (...args) => ($setup.toggleSidebar && $setup.toggleSidebar(...args)))
    }, _hoisted_6, 2)
  ], 4))
}